import { render, staticRenderFns } from "./Healthymind.vue?vue&type=template&id=e6c12cce&scoped=true"
import script from "./Healthymind.vue?vue&type=script&lang=js"
export * from "./Healthymind.vue?vue&type=script&lang=js"
import style0 from "./Healthymind.vue?vue&type=style&index=0&id=e6c12cce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_ckru7f3yypsoan6edyu23zfbiq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6c12cce",
  null
  
)

export default component.exports